// /**
//  * Dit is de file die de hele boel 'opstart' en die je in de html zet.
//  * Zie de javascript include.
//  */


// *
//  * De configuratie voor het hele require package.
//  * Vaak hoef je hier niks in te zetten, maar in dit geval hebben we jquery en observable nodig.
//  * Deze files exposen zichzelf al als require module, maar dan wel een een id. jquery heeft als id 'jquery'
//  * en dan moet je het ook zo 'requiren' (Stom maar waar).
//  *
//  * De baseUrl is de locatie van deze file (main.js).
//  * Alle scripts require je vanuit deze locatie (hier dus ./static/js/)
//  *

requirejs.config({
    baseUrl:'../static/js',
    paths: {
        jquery: 'vendor/jquery.min',
        mustache: 'vendor/mustache',
        infobox: 'vendor/infobox',
        templates: 'templates/mustache.templates',
        TweenLite: 'vendor/greensock/TweenLite',
        TweenLiteCSS: 'vendor/greensock/CSSPlugin',
        //TweenLiteEase: 'vendor/greensock/EasePack',
        TweenLiteScrollTo: 'vendor/greensock/ScrollToPlugin',
        TimelineLite: 'vendor/greensock/TimelineLite'
    }
});

// *
//  * Hier initialiseren we alles.
//  *
//  * Je laadt dus jquery en sunway.js en als die geladen zijn wordt de functie uitgevoerd.
//  *

requirejs(['jquery', 'sunway'], function($, sunway) {
    // $ is in dit geval het object dat jquery returned in de 'define' functie.
    // sunway is het object dat in de define functie in sunway.js wordt gereturned.
    // (zie onderaan sunway.js -> return sunway)
    sunway.init();
});

define("main", function(){});

